import React from 'react';

const NotFound = () => {
    document.title="404 || Ema-John-Simple"
    return (
        <div style={{textAlign: 'center',textTransform:'capitalize',color:'#555'}}>
            <h1>404</h1>
            <h2>page not found!!</h2>
        </div>
    );
};

export default NotFound;